import { render, staticRenderFns } from "./ProductImagesDropdown.vue?vue&type=template&id=7786cfe1&scoped=true"
import script from "./ProductImagesDropdown.vue?vue&type=script&lang=js"
export * from "./ProductImagesDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductImagesDropdown.vue?vue&type=style&index=0&id=7786cfe1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7786cfe1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7786cfe1')) {
      api.createRecord('7786cfe1', component.options)
    } else {
      api.reload('7786cfe1', component.options)
    }
    module.hot.accept("./ProductImagesDropdown.vue?vue&type=template&id=7786cfe1&scoped=true", function () {
      api.rerender('7786cfe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/ProductImagesDropdown.vue"
export default component.exports